module.exports = __webpack_public_path__ + "static/media/tips4.484d44fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/tips4.png
// module id = 424
// module chunks = 0